// @generated by protoc-gen-grpc-gateway-es v0.3.1 with parameter "target=ts,import_extension=none"
// @generated from file ai/h2o/engine/v1/dai_license_service.proto (package ai.h2o.engine.v1, syntax proto3)
/* eslint-disable */

import type { DAILicenseMetadata } from "./dai_license_pb";
import { RPC } from "../../../../runtime";

/**
 * Request message for getting DAI license metadata.
 * (-- api-linter: core::0131::request-name-required=disabled
 *     aip.dev/not-precedent: This is a singleton operation with no parameters. --)
 *
 * @generated from message ai.h2o.engine.v1.GetDAILicenseMetadataRequest
 */
export type GetDAILicenseMetadataRequest = {
}
;
/**
 * Response message for GetDAILicenseMetadata.
 *
 * @generated from message ai.h2o.engine.v1.GetDAILicenseMetadataResponse
 */
export type GetDAILicenseMetadataResponse = {
/**
 * DAI license metadata.
 *
 * @generated from field: ai.h2o.engine.v1.DAILicenseMetadata dai_license_metadata = 1;
 */
daiLicenseMetadata?: DAILicenseMetadata;
}
;
/**
 * Gets the configured DAI license metadata.
 *
 * Authorization: Any authenticated user.
 *
 * (-- api-linter: core::0131::http-uri-name=disabled
 *     aip.dev/not-precedent: This is a singleton operation with no parameters. --)
 * (-- api-linter: core::0131::request-name-required=disabled
 *     aip.dev/not-precedent: This is a singleton operation with no parameters. --)
 * (-- api-linter: core::0131::method-signature=disabled
 *     aip.dev/not-precedent: This is a singleton operation with no parameters. --)
 *
 * @generated from rpc ai.h2o.engine.v1.DAILicenseService.GetDAILicenseMetadata
 */
export const DAILicenseService_GetDAILicenseMetadata = new RPC<GetDAILicenseMetadataRequest,GetDAILicenseMetadataResponse>("GET", "/v1/daiLicenseMetadata");
